import { render } from "./DashboardMonthTotals.vue?vue&type=template&id=7120545f&scoped=true&ts=true"
import script from "./DashboardMonthTotals.vue?vue&type=script&lang=ts"
export * from "./DashboardMonthTotals.vue?vue&type=script&lang=ts"

import "./DashboardMonthTotals.vue?vue&type=style&index=0&id=7120545f&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7120545f"]])

export default __exports__